import "./css/style.css";

export default function PxmarketsLoadingScreen() {
    return (
        <div className="loading-screen">
            <div>
                <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="pxL100Blue" x1="0" y1="0" x2="0.4" y2="1">
                            <stop offset="0%"   stopColor="#b0ccff"/>
                            <stop offset="50%"  stopColor="#1a44cc"/>
                            <stop offset="100%" stopColor="#060e50"/>
                        </linearGradient>
                        <linearGradient id="pxL100Silver" x1="0.5" y1="0" x2="0.3" y2="1">
                            <stop offset="0%"   stopColor="#d4d8e8"/>
                            <stop offset="55%"  stopColor="#888ea8"/>
                            <stop offset="100%" stopColor="#404858"/>
                        </linearGradient>
                    </defs>
                    <style>{`
                        @keyframes pxBreatheUp100   { 0%,100%{transform:translate(2px,-3px)} 50%{transform:translate(6px,-10px)} }
                        @keyframes pxBreatheDown100 { 0%,100%{transform:translate(-2px,3px)} 50%{transform:translate(-6px,10px)} }
                        .px-l100-b { animation:pxBreatheUp100   1.4s ease-in-out infinite; transform-box:fill-box; transform-origin:center; }
                        .px-l100-s { animation:pxBreatheDown100 1.4s ease-in-out infinite; transform-box:fill-box; transform-origin:center; }
                    `}</style>
                    <polygon className="px-l100-b" points="19,10 89,10 80,72 62,72 68,28 34,28 16,28" fill="url(#pxL100Blue)"/>
                    <polygon className="px-l100-s" points="16,28 7,90 77,90 80,72 62,72 28,72 34,28" fill="url(#pxL100Silver)"/>
                </svg>
            </div>
        </div>
    );
}
